export function getHost() {
  const host = process.env.NEXT_PUBLIC_VERCEL_URL || '';
  // will be automatically injected by Vercel on build
  const protocol = host.startsWith('localhost') ? 'http' : 'https';
  return `${protocol}://${host}/`;
}
